import { ModuleState } from "../../Model/ModuleState";
import { EfiCompleted, AutoFocusCompleted, LocateDropCompleted } from '../../Model/Efi';

export enum EModuleStateAction {
  FETCH_MODULE_STATES_PENDING = "FETCH_MODULE_STATES_PENDING",
  FETCH_MODULE_STATES_SUCCESS = "FETCH_MODULE_STATES_SUCCESS",
  FETCH_MODULE_STATES_ERROR = "FETCH_MODULE_STATES_ERROR",
  UPDATE_MODULE_STATES = "UPDATE_MODULE_STATES",
  UPDATE_MODULE_STATE = "UPDATE_MODULE_STATE",
  UPDATE_MODULE_EFI_STATE = "UPDATE_MODULE_EFI_STATE",
  UPDATE_MODULE_LOCATE_DROP_STATE = "UPDATE_MODULE_LOCATE_DROP_STATE",
  UPDATE_MODULE_AUTO_FOCUS_STATE = "UPDATE_MODULE_AUTO_FOCUS_STATE",
  UPDATE_DISABLED_ARROW = "UPDATE_DISABLED_ARROW",
}

export interface ModuleStateAction {
  type: EModuleStateAction;
  error?: any;
  moduleStates?: ModuleState[];
  updatedModuleStates?: ModuleState[];
  updatedModuleState?: ModuleState
  updatedEfiState?: EfiCompleted;
  updatedAutoFocusState?: AutoFocusCompleted;
  updatedLocateDropState?: LocateDropCompleted;
  updateDisabledArrow?: boolean;
}

export function fetchModuleStatesPending(): ModuleStateAction {
  return {
    type: EModuleStateAction.FETCH_MODULE_STATES_PENDING,
  };
}

export function fetchModuleStatesSuccess(moduleStates: ModuleState[]): ModuleStateAction {
  return {
    type: EModuleStateAction.FETCH_MODULE_STATES_SUCCESS,
    moduleStates: moduleStates,
  };
}

export function fetchModuleStatesError(error: any): ModuleStateAction {
  return {
    type: EModuleStateAction.FETCH_MODULE_STATES_ERROR,
    error: error,
  };
}

export function updateModuleStates(updatedModuleStates: ModuleState[]): ModuleStateAction {
  return {
    type: EModuleStateAction.UPDATE_MODULE_STATES,
    updatedModuleStates: updatedModuleStates,
  };
}

export function updateModuleState(updatedModuleState: ModuleState): ModuleStateAction {
  return {
    type: EModuleStateAction.UPDATE_MODULE_STATE,
    updatedModuleState: updatedModuleState,
  };
}

export function updateModuleEfiState(updatedEfiState: EfiCompleted): ModuleStateAction {
  return {
    type: EModuleStateAction.UPDATE_MODULE_EFI_STATE,
    updatedEfiState: updatedEfiState,
  };
}

export function updateModuleAutoFocusState(updatedAutoFocusState: AutoFocusCompleted): ModuleStateAction {
  return {
    type: EModuleStateAction.UPDATE_MODULE_AUTO_FOCUS_STATE,
    updatedAutoFocusState: updatedAutoFocusState,
  };
}

export function updateModuleLocateDropState(updatedLocateDropState: LocateDropCompleted): ModuleStateAction {
  return {
    type: EModuleStateAction.UPDATE_MODULE_LOCATE_DROP_STATE,
    updatedLocateDropState: updatedLocateDropState,
  };
}

export function updateModuleDisabledArrow(payload: boolean) {
  return {
    type: EModuleStateAction.UPDATE_DISABLED_ARROW,
    updateDisabledArrow: payload,
  }
}
